import type { NextPage } from "next";

import Page from "../components/layout/page";
import TermlyEmbed from "../components/termly-embed";

const CookieNotice: NextPage = () => {
  return (
    <Page title="Cookie Notice" description="Learn how Enerflo uses cookies and similar technologies on our website.">
      <TermlyEmbed title="Enerflo Cookie Notice" id="22a5d5c4-4330-4cec-aaa8-773070eddaf6" />
    </Page>
  );
};

export default CookieNotice;
